import { Component, OnInit, ViewChild } from '@angular/core';
import { Employee } from './../model/employee.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ApiService } from './../../app/services/api.service';
import { EmployeeDialog } from '../dialogs/employee/employee.component';
import { CustomerBillsComponent } from '../dialogs/customerbills/customerbills.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DuebillsComponent } from '../dialogs/duebills/duebills.component';
import { Role } from '../model/role';
@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss'],
})
export class EmployeeComponent implements OnInit {
  // private apiService: ApiService
  displayedColumns: string[] = [
    'employeeName',
    'employeePhone',
    'employeeEmail',
    'dueBills',
    'billDetails',
    'allbillDetails'
  ];
  dataSource = new MatTableDataSource<Employee>(null);
  employee: Employee = {
    areaCode: null,
    employeeAction: 'add',
    employeePassword: '',
    employeeAreaId: '',
    employeeCreationDate: '2021-02-11',
    employeeEmail: '',
    employeeId: 123,
    employeeName: '',
    employeePhone: null,
    employeeRole: '',
    employeeStatus: '',
    roles:[],
    areas:[]
  };
  selectedEmployee: Employee;
  isSysAdmin:boolean = false;
  isSysAdminOrFinance : boolean = false;
  smsGloballyEnabled: boolean = true;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(
    public dialog: MatDialog,
    private apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {
    this.getEmployeeDetails();
    this.loadSmsSettings();

       const employeeId = window.localStorage.getItem("loggedInUser");

          this.apiService.getEmplyeeDetailsById(employeeId).subscribe((response) => {

               let roles = response.roles.map((role : Role)=>role.roleName);

               if(roles.includes("sysadmin")){
                this.isSysAdmin = true;
               }

                if(roles.includes("sysadmin") || roles.includes("finance")){
                this.isSysAdminOrFinance = true;
                this.displayedColumns = [
                      'employeeId',
                      'employeeName',
                      'employeePhone',
                      'employeeEmail',
                      'employeeRole',
                      'employeeStatus',
                      'smsEnabled',
                      'canCreateBill',
                      'canMakePayment',
                      'dueBills',
                      'billDetails',
                      'allbillDetails',
                      'actions',
                ];
               }

            });
  }

  loadSmsSettings(): void {
    this.apiService.getSmsSettings().subscribe({
      next: (res) => { this.smsGloballyEnabled = res && res.enabled !== false; },
      error: () => { this.smsGloballyEnabled = true; }
    });
  }

  toggleGlobalSms(): void {
    const newValue = !this.smsGloballyEnabled;
    const updatedBy = window.localStorage.getItem("loggedInUser");
    this.apiService.updateSmsSettings(newValue, updatedBy).subscribe({
      next: () => {
        this.smsGloballyEnabled = newValue;
        this._snackBar.open(newValue ? 'SMS notifications enabled' : 'SMS notifications disabled', 'Close', {
          duration: 3000,
        });
      },
      error: () => {
        this._snackBar.open('Failed to update SMS setting', 'Close', { duration: 3000 });
      }
    });
  }

  updateEmployeeSms(employeeData: Employee): void {
    employeeData.smsEnabled = !(employeeData.smsEnabled !== false);
    this.apiService.updateEmployee(employeeData).subscribe((data) => {
      if (data.isSuccess) {
        this._snackBar.open(
          employeeData.smsEnabled ? 'SMS enabled for ' + employeeData.employeeName : 'SMS disabled for ' + employeeData.employeeName,
          'Close', { duration: 3000 });
      }
    });
  }

  toggleCreateBill(employeeData: Employee): void {
    // NULL from older rows means allowed; store explicit boolean going forward.
    employeeData.canCreateBill = !(employeeData.canCreateBill !== false);
    this.apiService.updateEmployee(employeeData).subscribe((data) => {
      if (data.isSuccess) {
        this._snackBar.open(
          employeeData.canCreateBill
            ? 'Bill creation enabled for ' + employeeData.employeeName
            : 'Bill creation disabled for ' + employeeData.employeeName,
          'Close', { duration: 3000 });
      } else {
        employeeData.canCreateBill = !employeeData.canCreateBill; // revert on failure
      }
    });
  }

  toggleMakePayment(employeeData: Employee): void {
    employeeData.canMakePayment = !(employeeData.canMakePayment !== false);
    this.apiService.updateEmployee(employeeData).subscribe((data) => {
      if (data.isSuccess) {
        this._snackBar.open(
          employeeData.canMakePayment
            ? 'Payments enabled for ' + employeeData.employeeName
            : 'Payments disabled for ' + employeeData.employeeName,
          'Close', { duration: 3000 });
      } else {
        employeeData.canMakePayment = !employeeData.canMakePayment; // revert on failure
      }
    });
  }
  employees: Employee[] = [];
  ngOnInit(): void {}
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  getEmployeeDetails() {
    this.apiService.getEmployees().subscribe((data) => {
      data.employees.forEach((emp : Employee) => {
        emp.employeeRole = emp.roles.length > 0 
          ? emp.roles.map(role => role.roleName).join(", ") 
          : ""; // Assign empty string if no roles
     });
      
      this.dataSource = new MatTableDataSource<Employee>(data.employees);
      const newEmployeeId =  Math.max.apply(Math, data.employees.map(function(o : Employee) { return o.employeeId; }));
      this.employee.employeeId = newEmployeeId + 1;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = (data:
        Employee, filterValue: string) =>
        (data.employeeId.toString() == filterValue) ||
         (data.employeeName.trim().toLowerCase().indexOf(filterValue) !== -1) ;

    });
  }
  addEmployee(): void {
    const dialogRef = this.dialog.open(EmployeeDialog, {
      width: '600px',
      data: this.employee,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getEmployeeDetails();
    });
  }

  deleteEmployee(): void {
    this.apiService.deleteEmployees(this.selectedEmployee).subscribe((data) => {
      if (data.isSuccess) {
        this.getEmployeeDetails();
        this._snackBar.open('Employee deleted', 'Close', {
          duration: 3000,
        });
      }
    });
  }

  updateEmployee(employeeData: Employee): void {
    employeeData.employeeAction = 'update';
    const dialogRef = this.dialog.open(EmployeeDialog, {
      width: '600px',
      data: employeeData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getEmployeeDetails(); // Refresh the employee list
      }
    });
  }

  openDueBillsDialog(employeeData: Employee): void {
    employeeData.employeeAction = 'update';
    const dialogRef = this.dialog.open(DuebillsComponent, {
      width: '1200px',
      maxHeight:'80vh',
      data: employeeData,
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }
  openCollectorList(employeeData: Employee): void {
    employeeData.employeeAction="";
    const dialogRef = this.dialog.open(CustomerBillsComponent, {
      width: '1400px',
      maxHeight:'80vh',
      data: employeeData,
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }
  openAllCollectorList(employeeData: Employee): void {
    employeeData.employeeAction="all";
    const dialogRef = this.dialog.open(CustomerBillsComponent, {
      width: '1400px',
      data: employeeData
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  refreshCollectorList(){
    this.apiService.refreshListCollector().subscribe((data) => {
      if(data.isSuccess){
        this._snackBar.open('Dhammaan Liis ururiyaha waa la cusboonaysiiyay Waxay qaadan doontaa ilaa 2 Daqiiqo', 'Close', {
          duration: 3000,
        });
      }
    });
  }


  updateEmployeeStatus(employeeData: Employee): void {
    if (employeeData.employeeStatus === 'Y') {
      employeeData.employeeStatus = 'N';
    } else if (employeeData.employeeStatus === 'N') {
      employeeData.employeeStatus = 'Y';
    }
    this.apiService.updateEmployee(employeeData).subscribe((data) => {
      if(data.isSuccess){
        this._snackBar.open('Employee status updated', 'Close', {
          duration: 3000,
        });
      }
    });



    
  }
}
